import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '娱乐', path: '/category/entertainment' },
  { label: '资讯', path: '/category/news' },
  { label: '购物', path: '/category/shopping' },
  { label: '社交', path: '/category/social' },
  { label: '科技', path: '/category/tech' },
  { label: '生活', path: '/category/lifestyle' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <h1 className="font-heading text-xl font-bold text-foreground-900">
              亚洲<span className="text-primary-500">在线</span>
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              加入会员
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/70">
              <Link
                to="/about"
                className="flex-1 text-center px-4 py-2 text-sm border border-foreground-200 rounded-full text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                登录
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                加入会员
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}